// extracted by mini-css-extract-plugin
module.exports = {"divFooter":"footer_divFooter__BlJsu","myLink":"footer_myLink__UhMOi"};